import { Component } from "@angular/core";
import { ITooltipAngularComp } from "ag-grid-angular";
import { ITooltipParams } from 'ag-grid-community';


@Component({
    selector: 'tooltip-component',
    template: ` <div class="notificationtooltip">
    <span>{{ data }}</span>
    </div>`,
    styles: [
        `
      .notificationtooltip {
        background-color: black;
        opacity: 0.75;
        color: white;
        display: inline-block;
        white-space: pre-line;
        width: 500px;
      }
      `,
    ],
    standalone: false // NOSONAR
})

export class notificationtooltip implements ITooltipAngularComp {

    public data: any;
    public field: string;

    agInit(params: { field: string } & ITooltipParams): void {
        this.data = params.data.userIds;
        console.info('data...',this.data);
    }
}
